import { Stack } from "@mui/material";
import { useSearch } from "@tanstack/react-router";
import { useContext } from "react";
import { entitiesUrl } from "src/utils/formatUrl";

import ConnectDynamicForm from "../../../DynamicForm/ConnectDynamicForm.tsx";
import { CustomConnectProps } from "../../../DynamicForm/context.ts";
import BackBtn from "../../Common/BackBtn.tsx";
import LogoViewer from "../../Common/ConnectStep/LogoViewer.tsx";
import CrossExitBtn from "../../Common/InfoStep/components/CrossExitBtn/CrossExitBtn.tsx";
import ThemeContext from "../../context.ts";
import { ConnectAccountParams } from "../ConnectAccount.tsx";
import Context from "../context.ts";
import useGetConnectCallback from "./hook/useGetConnectCallback.tsx";

// ----------------------------------------------------------------------

export const ConnectStep = () => {
	const { updateToken, restoreToken, externalId } = useContext(Context);
	const { state, actions, id, theme, themeType, isFrame } = useContext(ThemeContext);

	const { entity }: ConnectAccountParams = useSearch({
		strict: false
	});

	const { onConnect } = useGetConnectCallback();

	const formProps: CustomConnectProps = {
		onConnect,
		updateToken,
		restoreToken,
		externalId,
		theme,
		themeType,
		showSaveCheckbox: !!!restoreToken && !!!updateToken && !state.entity?.maintenance
	};

	return (
		<Stack minWidth={{ xs: 250, sm: 330 }}>
			{!updateToken && <BackBtn onClick={() => actions.setStep(entity ? 0 : 1)} />}
			<LogoViewer src={entitiesUrl(state.entity?.id ?? "")} />
			{!isFrame && theme?.showExit && <CrossExitBtn />}
			<ConnectDynamicForm id={id} entity={state.entity} customConnectProps={formProps} />
		</Stack>
	);
};

export default ConnectStep;
